import { render, staticRenderFns } from "./ProviderDetailOPPayable.vue?vue&type=template&id=73c73300&"
import script from "./ProviderDetailOPPayable.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailOPPayable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports